"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const ChallengeStatus_1 = require("../../enums/ChallengeStatus");
const ScenarioType_1 = require("../../enums/ScenarioType");
const UserLookupType_1 = require("../../enums/UserLookupType");
const siteText_1 = tslib_1.__importDefault(require("../../mixins/siteText"));
const sitetext_1 = require("../../filters/sitetext");
const SlideHeaderWithNav_vue_1 = tslib_1.__importDefault(require("../SlideHeaderWithNav.vue"));
const ContainerSlide_vue_1 = tslib_1.__importDefault(require("../ContainerSlide.vue"));
const IsotopeHeader_vue_1 = tslib_1.__importDefault(require("../IsotopeHeader.vue"));
const userTelemetry_1 = require("../../api/userTelemetry");
exports.default = vue_1.default.extend({
    name: 'choose-scenario',
    data: () => {
        return {
            selectedScenario: 0,
        };
    },
    props: {
        cardName: {
            type: String,
            required: false,
            validator: prop => typeof prop === 'string' || prop === null,
            default: null,
        },
    },
    computed: {
        isMobile() {
            return this.$store.getters.isMobile;
        },
        canContinue() {
            return this.selectedScenario !== 0;
        },
        submitting() {
            return this.$store.getters.isSubmittingChallenge;
        },
        currentChallenge() {
            return this.$store.state.currentChallenge;
        },
        scenarios() {
            return this.$store.state.currentChallenge.Scenarios || [];
        },
    },
    mixins: [siteText_1.default],
    filters: {
        sitetext: sitetext_1.siteTextFilter,
    },
    methods: {
        baseUrl() {
            return this.$store.state.configuration.baseUrl;
        },
        scenarioType() {
            const type = this.scenarios.length > 0 ? this.scenarios[0].ScenarioTypeValue : 0;
            return ScenarioType_1.ScenarioType[type];
        },
        async selectScenario(selectedItem) {
            var _a, _b;
            this.selectedScenario = selectedItem;
            const workflow = (0, userTelemetry_1.getWorkflowName)(this.$store.getters.workflow);
            if (workflow !== userTelemetry_1.workflowName.unknown) {
                let lookupType = (_b = (_a = this.scenarios.find(s => s.Id === selectedItem)) === null || _a === void 0 ? void 0 : _a.UserLookupTypeValue) !== null && _b !== void 0 ? _b : UserLookupType_1.UserLookupType.None;
                void userTelemetry_1.telemetry.custom({
                    workflowName: workflow,
                    action: lookupType === UserLookupType_1.UserLookupType.Business ? userTelemetry_1.userAction.business_account_clicked : userTelemetry_1.userAction.individual_account_clicked,
                    stepType: userTelemetry_1.stepType.progression,
                    stepName: userTelemetry_1.stepName.registration_type,
                });
            }
            await this.submitForm();
        },
        async submitForm() {
            if (this.submitting) {
                return;
            }
            let chosenScenario = this.selectedScenario;
            if (!chosenScenario) {
                const validationResults = [
                    {
                        CustomSubCode: '',
                        ErrorCode: 0,
                        Field: 'Choose Scenario Type',
                        ItemIndex: 0,
                        Message: `Unable to determine scenario Selected: ${this.selectedScenario} Allowed:${this.scenarios.join('|')}`,
                        Origin: 'ChooseScenario (FrontEnd)',
                        Severity: 1,
                        SubCode: 0,
                    },
                ];
                this.$store.commit('errors', validationResults);
                return;
            }
            let challenge = {
                ...this.currentChallenge,
                ChosenScenarioId: chosenScenario,
            };
            // reset the challenge status before submitting so we pick up a new one
            this.$store.commit('challengeStatus', ChallengeStatus_1.ChallengeStatus.Unknown);
            // submit the challenge
            await this.$store.dispatch('submitChallenge', challenge);
        },
    },
    components: {
        SlideHeaderWithNav: SlideHeaderWithNav_vue_1.default,
        ContainerSlide: ContainerSlide_vue_1.default,
        IsotopeHeader: IsotopeHeader_vue_1.default,
    },
});
